import { createTheme, MantineProvider } from "@mantine/core";
import React from "react";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/charts/styles.css";

const theme = createTheme({
  colors: {
    primary: [
      "#ebfef6",
      "#cefde9",
      "#a2f8d6",
      "#66efc3",
      "#29deaa",
      "#05c493",
      "#00a079",
      "#008064",
      "#006b55",
      "#015343",
      // "#002e20",
    ],
    dark: [
      "#9A9B9A", // Deep gray, barely any lightness
      "#7F807F", // Dark neutral gray
      "#656665", // Charcoal gray, very muted
      "#4A4B4A", // Almost black, minimal color tone
      "#343534", // Deep neutral black with the slightest depth
      "#252625", // Nearly pure black, soft enough for contrast
      "#181918", // Very deep black with a tiny hint of green-gray
      "#0F100F", // Almost absolute black, only slight visibility
      "#080808", // Practically pure black, just above full black
      "#030303",
    ],
  },
  primaryColor: "primary",
  fontFamily: "Poppins, sans-serif",
  fontFamilyMonospace: "Poppins, sans-serif",
  headings: { fontFamily: 'Outfit, sans-serif' },
});

export default function AppMantineProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme={"light"}
    // defaultProps={{
    //   Select: {
    //     maxDropdownHeight: 200,
    //     comboboxProps: {
    //       transitionProps: { transition: 'fade', duration: 0 },
    //     },
    //   },
    // }}
    >
      {children}
    </MantineProvider>
  );
}
